import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
} from "@mui/material";

import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import AcUnitIcon from '@mui/icons-material/AcUnit';
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import instruments from "../Assets/Images/instruments2.png"

const IMAGE =
  "https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/image_about.png";

export default function AboutSecondSection() {
  return (
    <Box
      sx={{
        position: "relative",
        zIndex: 2,
        mt: "-80px", // 🔑 overlap with hero
        pb: { xs: 10, md: 14 },
      }}
    >
      <Box>
        {/* ROUNDED CARD */}
        <Box
          sx={{
            backgroundColor: "#fbf8f2",
            borderRadius: "60px",
            px: { xs: 4, md: 10 },
            py: { xs: 6, md: 10 },
              pb: { xs: 16, md: 18 },
          }}
        >
          <Grid container spacing={8} alignItems="flex-start">
            {/* LEFT CONTENT */}
            <Grid item xs={12} lg={7}>
              {/* ABOUT US */}
              <Typography
                sx={{
                  fontFamily: "'Playfair Display', serif",
                    fontStyle: "italic",
                  fontWeight: 500,
                  color: "#ff7a00",
                  fontSize: "0.95rem",
                  mb: 2,
                }}
              >
                About us
              </Typography>

              {/* MAIN HEADING */}
              <Typography
                sx={{
                  fontFamily: "Inter Tight, sans-serif",
                  fontWeight: 600,
                  fontSize: { xs: "1.8rem", md: "2.4rem" },
                  lineHeight: 1.25,
                  mb: 3,
                  maxWidth: 620,
                }}
              >
                Restoring More Than Just Homes—We Restore Lives.
              </Typography>

              {/* DESCRIPTION */}
              <Typography
                sx={{
                  color: "#555",
                  maxWidth: 560,
                  mb: 6,
                }}
              >
                Proudly serving Bloomington and Monroe County with integrity, speed, and 
expert care.
              </Typography>

              {/* FEATURES */}
              <Grid container spacing={5}>
                {[
                  {
                    icon: <ShieldOutlinedIcon />,
                    title: "Trusted Professionals",
                    text:
                      "Our Serviceman are thoroughly vetted, trained, and to quality service. We treat your space with the same care and respect we give our own.",
                  },
                  {
                    icon: <EventAvailableOutlinedIcon />,
                    title: "Flexible Scheduling",
                    text:
                      "Life gets busy. That’s why we offer flexible booking options including weekly, monthly, and one-time cleanings, always on your terms.",
                  },
                  {
                    icon: <AcUnitIcon />,
                    title: "Eco-Friendly Cleaning",
                    text:
                      "We use non-toxic, environmentally friendly products that are safe for children, pets, and the planet without compromising on results.",
                  },
                  {
                    icon: <FavoriteBorderOutlinedIcon />,
                    title: "Customized Service Plans",
                    text:
                      "From a light refresh to a deep clean, we tailor every service to your needs and budget. You’ll never pay for more than you need.",
                  },
                ].map((item, i) => (
                  <Grid item xs={12} sm={6} key={i}>
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <Box
                        sx={{
                          color: "#4f9b50",
                          fontSize: "1.8rem",
                          mt: "2px",
                        }}
                      >
                        {item.icon}
                      </Box>
                      <Box>
                        <Typography fontWeight={600} mb={1}>
                          {item.title}
                        </Typography>
                        <Typography fontSize="0.95rem" color="#555">
                          {item.text}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {/* RIGHT IMAGE */}
            <Grid item xs={12} lg={5}>
              <Box
                sx={{
                  position: "relative",
                  backgroundColor: "#4f9b50",
                  borderRadius: "40px",
                  p: 4,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  component="img"
                  src={instruments}
                  alt="Cleaning tools"
                  sx={{
                    width: "100%",
                    maxWidth: 380,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
